import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface SidebarState {
    showSideBar: boolean;
    sideBarMenus: string[];
    showHoldingJobs: boolean;
    setShowSideBar: (show: boolean) => void;
    setSideBarMenus: (menus: string[]) => void;
    toggleHoldingJobs: () => void;
    handleMenuClick: (menuItem: string) => void;
}

export const useSidebarStore = create<SidebarState>()(
    devtools((set) => ({
        showSideBar: false,
        sideBarMenus: [],
        showHoldingJobs: false,

        // Actions
        setShowSideBar: (show) => set({ showSideBar: show }),
        setSideBarMenus: (menus) => set({ sideBarMenus: menus }),
        toggleHoldingJobs: () => set((state) => ({ showHoldingJobs: !state.showHoldingJobs })),

        // Handle menu item click
        handleMenuClick: (menuItem) => {
            set({ showSideBar: false });
            if (menuItem === "Holding Jobs") {
                set((state) => ({ showHoldingJobs: !state.showHoldingJobs }));
            }
        },
    }))
);
